import { Pipe, PipeTransform } from '@angular/core';

import { ResourceSuggestionWithDetails } from '@app/learner-home/learner-home-api.model';
import { RecommendationInfo } from '@app/shared/models/core-api.model';

/** Converts a ResourceSuggestionWithDetails containing a recommendation text to a RecommendationForUser */
@Pipe({
  name: 'recommendationInfo',
  pure: true,
})
export class RecommendationInfoPipe implements PipeTransform {
  public constructor() {}

  public transform(resourceSuggestion: ResourceSuggestionWithDetails) {
    return {
      ...resourceSuggestion.recommendation,
      reference: resourceSuggestion.reference,
      configuredAssignmentType:
        resourceSuggestion.suggestionDetails.configuredAssignmentType,
      userProfileKey:
        resourceSuggestion.suggestionDetails?.sourceUser?.userProfileKey,
    } as any as RecommendationInfo;
  }
}
